import script from "./LeaderProjectFormStep8.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep8.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep8.vue?vue&type=style&index=0&id=0ccc510b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ccc510b"]])

export default __exports__